import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
import {
  CertExperienceButton,
  CertExperienceButtonWrapper,
  CertSurveyBottomButton,
  CertTitle,
  CertWrapper,
} from "./styles/cert";
import { enqueueSnackbar } from "notistack";

interface StepProps {
  certExperience: number | null;
  setCertExperience: (experience: number | null) => void;
  onNext: () => void;
}

const StepCertExperience = ({
  certExperience,
  setCertExperience,
  onNext,
}: StepProps) => {
  const inset = useRecoilValue(insetState);

  const handleNext = () => {
    if (certExperience === null) {
      enqueueSnackbar("홀덤 플레이 경험 수준을 알려주세요!", {
        variant: "error",
      });
      return;
    }
    onNext();
  };
  return (
    <CertWrapper isApp={inset}>
      <CertTitle>
        홀덤 플레이 경험 수준을
        <br />
        알려주세요
      </CertTitle>
      <CertExperienceButtonWrapper>
        <CertExperienceButton
          isSelected={certExperience === 36}
          onClick={() => setCertExperience(36)}
        >
          👑 3년 이상
        </CertExperienceButton>
        <CertExperienceButton
          isSelected={certExperience === 12}
          onClick={() => setCertExperience(12)}
        >
          🃏 1년 이상
        </CertExperienceButton>
        <CertExperienceButton
          isSelected={certExperience === 3}
          onClick={() => setCertExperience(3)}
        >
          🎲 3개월 이상
        </CertExperienceButton>
        <CertExperienceButton
          isSelected={certExperience === 1}
          onClick={() => setCertExperience(1)}
        >
          🐣 홀덤 초보
        </CertExperienceButton>
      </CertExperienceButtonWrapper>

      <CertSurveyBottomButton
        isSelected={certExperience !== null}
        onClick={() => handleNext()}
      >
        다음
      </CertSurveyBottomButton>
    </CertWrapper>
  );
};

export default StepCertExperience;
